import React from 'react'

const TypeRender = ({row}) => {
  return (
    <>
    {row.payments.map((pay, index) => (
      <p style={{borderBottom:"1px solid #F7F9FB"}}>{pay.paymentType}</p>
    ))}
  </>
  )
}

export default TypeRender
